
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { logout } from '@/utils/auth';
const LogoutPage = () => {
    const router = useRouter();
    useEffect(() => {
        const performLogout = async () => {
            await logout();
            router.push('/');
        };
        performLogout();
    }, [router]);
    return null;
};
export default LogoutPage;

    async function __Next_Translate__getStaticProps__1a11b03d0b5__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/logout',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a11b03d0b5__ as getStaticProps }
  